export default {
    token: localStorage.getItem("token"),
    user: JSON.parse(localStorage.getItem("user")),
    online: []
}
